import { render } from "./VLemonade.vue?vue&type=template&id=24c527be"
const script = {}

import exportComponent from "../../../../../../../../projects/loyalzilla_admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/icons/package/VLemonade.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "24c527be"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('24c527be', __exports__)) {
    api.reload('24c527be', __exports__)
  }
  
  module.hot.accept("./VLemonade.vue?vue&type=template&id=24c527be", () => {
    api.rerender('24c527be', render)
  })

}


export default __exports__